module.exports = __webpack_public_path__ + "static/media/github.144b6307.svg";